export const getNewIds = (prevItems, nextItems, key = 'id') => {
  const prevIds = new Set(prevItems.map(item => item[key]));
  return nextItems
    .filter(item => !prevIds.has(item[key]))
    .map(item => item[key]);
};

export const hasListChanged = (prevItems, nextItems, key = 'id') => {
  if (prevItems.length !== nextItems.length) return true;
  const prevIds = prevItems.map(item => item[key]).sort().join(',');
  const nextIds = nextItems.map(item => item[key]).sort().join(',');
  return prevIds !== nextIds;
};
